module.exports = __webpack_public_path__ + "img/sdgs_header.87319852.jpg";